export const environment = {
    production: false,
    environmentName: 'development',
    apiUrl: '',
    debugMode: true,
    enableLogs: true, // Disable console logs for production environment
    featureFlags: {
        enableAnalytics: true,
        enableExperimentalFeatures: false
    },
    services: {
        auth: {
            baseUrl: 'http://localhost:8090',
            basePath: '/auth/v1',
            auth0ClientId: 'B0tkaimqN7BCi7NhksPowIqj0N41t44L',
            auth0Domain: 'hundredxinc-development.auth0.com',
            auth0AudienceDomain: 'hundredxinc-development.auth0.com',
            auth0CallbackURL: 'http://localhost:4100/login?callback=true',
            federatedSignout: true
        },
        firebaseToken: {
            baseUrl: 'https://api.dev.hundredxinc.com',
            basePath: '/auth/v1/firebase/token'
        },
        account: {
            baseUrl: 'http://localhost:8080',
            basePath: '/account/v1'
        },
        contact: {
            baseUrl: 'http://localhost:8082',
            basePath: '/contact/v1'
        },
        feedback: {
            baseUrl: 'http://localhost:8086',
            basePath: '/feedback/v1'
        },
        participant: {
            baseUrl: 'http://localhost:8081',
            basePath: '/participant/v1'
        },
        transaction: {
            baseUrl: 'http://localhost:8083',
            basePath: '/transaction/v1'
        },
        solution: {
            baseUrl: 'http://localhost:8084',
            basePath: '/solution/v1',
            efgAccountId: 1017
        },
        cbreService: {
            baseUrl: 'http://localhost:8100',
            basePath: '/cbre/v1'
        },
        reporting: {
            baseUrl: 'http://localhost:8089',
            basePath: '/reporting/v1'
        },
        data: {
            baseUrl: 'http://localhost:8093',
            basePath: '/data/v1'
        },
        regionSync: {
            baseUrl: 'http://localhost:3000',
            basePath: ''
        },
        masterData: {
            baseUrl: 'http://localhost:8094',
            basePath: '/master-data/v1'
        },
        plc: {
            baseUrl: 'http://localhost:8096',
            basePath: '/plc/v1'
        }
    }
};